"use client";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AuthHeader from "../../_components/header";
import { useAuthContext } from "../../_components/authProvider";
import { FormEvent, useState } from "react";
import { LoaderCircle } from "lucide-react";
import { signIn } from "next-auth/react";
import Messages from "../../_components/messages";
import { checkIfUserWithEmailExists } from "../../../../../../features/auth/lib/actions";
import { homePath } from "@/features/auth/utils";
import { t } from "@/lib/localization";
import { useLocale } from "@/hooks/useLocale";

export default function ResetPasswordForm() {
    const [email, setEmail] = useState("");
    const { locale } = useLocale();
    const withLocale = (path: string) => `/${locale}${path}`;

    const { loading, setLoading, setErrorMessage, setSuccessMessage } =
        useAuthContext();

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setSuccessMessage(null);
        setErrorMessage(null);
        setLoading(true);

        const isUserExists = await checkIfUserWithEmailExists(email);

        if (isUserExists) {
            await signIn("resend", {
                email,
                redirectTo: withLocale(homePath),
            });

            // setSuccessMessage({
            //     keyName: "auth.success-message.reset-passord-mail",
            //     defaultValue: "מייל אימות נשלח בהצלחה!",
            // });
        } else {
            setErrorMessage({
                keyName: "auth.error-message.reset-passord.user-not-found",
                defaultValue: t("auth.error-message.reset-passord.user-not-found"),
            });
        }

        setLoading(false);
    };

    return (
        <form onSubmit={handleSubmit} className="p-6 md:p-8">
            <div className="flex flex-col gap-6">
                <AuthHeader
                    title={{
                        keyName: "reset-password.title",
                        defaultValue: t("reset-password.title"),
                    }}
                    description={{
                        keyName: "reset-password.description",
                        defaultValue: t("reset-password.description"),
                    }}
                />

                <div className="grid gap-2">
                    <div className="flex items-center">
                        <Label htmlFor="email">
                            {t("reset-password.email", undefined, undefined)}
                        </Label>
                    </div>
                    <Input
                        disabled={loading}
                        id="email"
                        type="email"
                        placeholder="name@example.com"
                        value={email}
                        onChange={(e) => {
                            setErrorMessage(null);
                            setEmail(e.target.value.toLowerCase());
                        }}
                        required
                    />
                </div>

                <Messages />

                <div className="flex flex-col w-full mt-2 gap-4">
                    <Button disabled={loading} type="submit" className="w-full">
                        {loading ? (
                            <LoaderCircle className="size-4 animate-spin" />
                        ) : (
                            t("reset-password.submit-btn", undefined, undefined)
                        )}
                    </Button>
                </div>

                <div className="text-center text-sm">
                    <a
                        href={withLocale("/auth/login")}
                        className="underline underline-offset-4"
                    >
                        {t("reset-password.login-link")}
                    </a>
                </div>
            </div>
        </form>
    );
}
